import qs from 'qs';

/**
 * This function takes in a Location object and returns
 * the string of all the query params in the form of
 *
 * `param1=val1&param2=val2&...`
 *
 * @param location Object - Location object from Window.location
 */
const getParams = (location) => {
  if (!location || !location.search || !location.search.substr) { return {}; }

  return qs.parse(location.search.substr(1));
};

export default getParams;
